import { render, staticRenderFns } from "./DefCheckbox.vue?vue&type=template&id=dbe70e78&scoped=true&"
import script from "./DefCheckbox.vue?vue&type=script&lang=js&"
export * from "./DefCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DefCheckbox.vue?vue&type=style&index=0&id=dbe70e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe70e78",
  null
  
)

export default component.exports